import { OnboardingStep } from './StatusOnboarding.types';

export const ONBOARDING_STEPS = Object.values(OnboardingStep);

export const COMMON_STYLES = {
  width: '100%',
  maxWidth: {
    mobile: undefined,
    tablet: 375,
    desktop: 375,
  },
  paddingHorizontal: 'space-600',
} as const;
